var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 290,
    viewBox: "0 0 256 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.11 0L231.868 260.36L127.399 289.322L23.2165 260.401L0 0H255.11Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.555 267.184L211.971 243.78L231.832 21.291H127.555V267.184Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3759 85.1659H127.556V53.2285H47.4727L48.2371 61.7968L56.0866 149.807H127.556V117.87H85.2945L82.3759 85.1659Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5735 165.776H57.5137L61.988 215.922L127.409 234.083L127.556 234.043V200.815L127.416 200.852L91.8472 191.248L89.5735 165.776Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 149.808H166.772L163.065 191.228L127.445 200.842V234.068L192.918 215.923L193.398 210.527L200.903 126.447L201.683 117.871H127.445V149.808Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.445 85.0879V85.1659H204.589L205.229 77.9874L206.684 61.7968L207.448 53.2285H127.445V85.0879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.75bdf0b057c088503944680032ea6347.svg";
export { ForwardRef as ReactComponent };